import { Avatar, Box, Card, Text } from 'grommet';
import { Deliver, Group } from 'grommet-icons';
import React, { useState } from 'react';

import { Driver } from '../../context/model/types';
import { useUsers } from '../../context/users';
import DriverAvailabilityModal from '../Modals/DriverAvailabilityModal';

interface CardProps {
  user: Driver;
  type: 'customer' | 'driver';
}

export const DriverCard = ({ user, type }: CardProps): JSX.Element => {
  const { setDrivers } = useUsers();
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);

  const handleAvailabilitySaved = (updated: Driver) => {
    setDrivers(prev => prev.map(d => d.id === updated.id ? updated : d));
  };

  return (
    <>
      <Card
        fill
        round="xsmall"
        background="light-1"
        hoverIndicator={{ elevation: 'large' }}
        focusIndicator={false}
      >
        <Box fill direction="row" align="center" gap="medium" pad="small">
          <Avatar
            size="large"
            src="https://1.gravatar.com/userimage/212100380/bfb34d02a1e842372821360907aa9583?size=256"
          />

          <Box flex justify="between" direction="row" align="stretch">
            <Box>
              <Box direction="row" align="center" gap="xsmall">
                <Text>{`${user.name}`}</Text>
                {type === 'customer' ? (
                  <Group size="xsmall" />
                ) : (
                  <Deliver size="xsmall" />
                )}
              </Box>
            </Box>
          </Box>

          <Box direction="row" gap="small">
            <button
              type="button"
              onClick={() => setShowAvailabilityModal(true)}
              style={{
                padding: '6px 12px',
                borderRadius: 6,
                border: '1px solid #7B1FA2',
                background: 'transparent',
                color: '#7B1FA2',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              Edit schedule
            </button>
          </Box>
        </Box>
      </Card>

      {showAvailabilityModal && (
        <DriverAvailabilityModal
          driver={user}
          setShow={setShowAvailabilityModal}
          onSave={handleAvailabilitySaved}
        />
      )}
    </>
  );
};

export default DriverCard;
